//this is a set of tools to use with img tags contained by picture tags
import $ from 'jquery'
var MobileDetect = window.MobileDetect || new (require('mobile-detect'))(window.navigator.userAgent);
//these methods will be called IN ORDER on each image having the property name as class
var _methods = {
    cover: {
        doOn: ['resize', 'ready', 'load', 'update'],
        handler: function () {
            var $img = $(this),
                $parent = $(this).parent(),
                w1, h1, w2, h2;

            w1 = $img.width();
            h1 = $img.height();
            w2 = $parent.outerWidth();
            h2 = $parent.outerHeight();

            if (w1 / h1 < w2 / h2) {
                $img.css('width', '100%');
                $img.css('height', 'auto');
            } else {
                $img.css('width', 'auto');
                $img.css('height', '100%');
            }
        }
    },
    parallax: {
        doOn: ['ready', 'resize', 'load', 'scroll', 'update'],
        handler: function (eventName) {
            //iOS is the anti Bob Ross: it can't paint for shouwit
            if (MobileDetect.mobile()) {
                $(this).addClass('cover')
                _methods.cover.handler.call(this, eventName);
                return;
            }

            var $img = $(this),
                $parent = $(this).parent(),
                doc = document.documentElement,
                f = $img.attr('data-parallax-speed') ? parseFloat($img.attr('data-parallax-speed')) : 0.8,
                vh = window.innerHeight,
                vw = window.innerWidth,
                zh = $parent.outerHeight(),
                zw = $parent.outerWidth(),
                vt = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0),
                vl = 0, //might be set eventually
                ih, zl, zt, imgPosX, imgPosY, iw, scale, ratio;

            //if preload is on the image, wait
            if ($img.is('.preload') && document.readyState !== "complete")
                return;


            switch (eventName) {
                case 'ready':
                case 'load':
                case 'resize':
                case 'scroll':
                    //we need a default src, else we won't be able to go back to the default image after a resolution change
                    if (!$parent.attr('data-default-src') || $parent.attr('data-default-src') === '//:0')
                        $parent.attr('data-default-src', $img.attr('src'));
                    $parent.addClass('parallax-parent');
                    $img.css('visibility', 'hidden');

                    //to do: move this somewhere else in order to prevent a repaint on the scroll event
                    $parent.css('background-image', 'url(' + $img.attr('src') + ')');
                    $parent.css('background-attachment', 'fixed');
                    $parent.css('background-repeat', 'no-repeat');

                    //set the ratio, but only if the image is visible
                    if (!$img.is('[data-ratio]') && $img.height() !== 0 && $img.width() !== 0) {
                        ratio = $img.width() / $img.height();
                        $img.attr('data-ratio', ratio);
                    } else {
                        ratio = parseFloat($img.attr('data-ratio')) || 1;
                    }

                    zl = $parent.offset().left;
                    zt = $parent.offset().top;

                    //some insane math
                    ih = f * (vh - zh) + zh;
                    iw = ih * ratio;

                    if (zw > iw)
                        scale = zw / iw;
                    else
                        scale = 1;

                    imgPosX = (zl - vl) + (zw - iw * scale) / 2;
                    imgPosY = (zt - vt) - f * (zt - vt);

                    //to do: move this on requestAnimationFrame in order to prevent a repaint on the scroll event
                    $parent.css('background-size', (iw * scale) + 'px ' + (ih * scale) + 'px');
                    $parent.css('background-position', imgPosX + 'px ' + imgPosY + 'px');
                    break;
                case 'loop':
                    break;
                default:
                    break;
            }
        }
    }
};

var _getSrcFromPicture = function ($picture, defaultPath) {
    var path = defaultPath || $picture.find('img').attr('src');
    $picture.find('source').each(function () {
        var $el = $(this);
        if (Modernizr.mq($el.attr('media'))) {
            path = $el.attr('srcset');
            return;
        }
    });
    return path;
};

var _resizeHandler = function (eventName) {
    var $this = $(this),
        orderInc = 0,
        orderClasses = _getClassesFromMethods();

    //we reset dimensions here so that we can stack some operations
    $this.css('width', 'auto');
    $this.css('height', 'auto');
    $this.css('transform', '');

    //load order
    for (var i = 0; i < orderClasses.length; i++) {
        if ($this.is('.' + orderClasses[i])) {
            //ATT: make sure that context is still current HTMLElement
            //_frameDelayer(this, _methods[orderClasses[i]].handler, orderInc);
            //orderInc += 2;
            _methods[orderClasses[i]].handler.call(this, eventName)
        }
    }
};

var _getClassesFromMethods = function () {
    var classes = [];
    for (var i in _methods) {
        if (_methods.hasOwnProperty(i)) {
            classes.push(i);
        }
    }
    return classes;
};



var _updateImages = function (eventName, selector) {
    var classes = _getClassesFromMethods(),
        $root = $(selector || 'html');

    $.each(classes, function (index, name) {
        if (_methods[name].doOn.indexOf(eventName) > -1) {
            $root.find('img.' + name).each(function () {
                var $img = $(this);

                if (!$img[0].complete) {
                    var handler = function () {
                        _resizeHandler.call(this, eventName);
                        $img.off('load', handler);
                    };
                    $img.on('load', handler);
                } else
                    _resizeHandler.call(this, eventName);
            });
        }
    });
};

var _loop = function () {
    _updateImages('loop');
    requestAnimationFrame(_loop);
};

$().ready(function () {
    _updateImages('ready');

    _loop();

    $(window).on('load', function () {
        _updateImages('load');
    });

    $(window).resize(function () {
        _updateImages('resize');
    });
    $(window).on('scroll', function () {
        _updateImages('scroll');
    });

});

function update(selector) {
    _updateImages('update', selector);
}

export { update }
/*module.exports = {
    //arbitrary update
    update: function (selector) {
        _updateImages('update', selector);
    }
};*/